/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_Run_CanvasInputs */

const cs_settings_automation_run_canvas = /** @type {(inputs: Settings_Automation_Run_CanvasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graf běhu`)
};

const en_settings_automation_run_canvas = /** @type {(inputs: Settings_Automation_Run_CanvasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execution graph`)
};

/**
* | output |
* | --- |
* | "Execution graph" |
*
* @param {Settings_Automation_Run_CanvasInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_run_canvas = /** @type {((inputs?: Settings_Automation_Run_CanvasInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_Run_CanvasInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_run_canvas(inputs)
	return cs_settings_automation_run_canvas(inputs)
});